import React from 'react';
import { Tick, ThinCross } from '../elements/Icon';

export const BetterHearing = (props) => {
   
    const { heading, subHeading, features, yesHearingImage } = props; 
    return (
        <section className="bg-[#f6f9ff] md:pb-[7rem] px-4 md:px-10 text-center font-sans">
            <div className="main-content-section max-w-6xl mx-auto">
                {/* Heading */}
                <p className="text-sm text-[#2664EB] font-semibold uppercase tracking-wide mb-2">
                    {subHeading}
                </p>
                <h2 className="text-[42px] font-extrabold text-[#19335C] mb-10">
                    {heading}
                </h2>
        
                {/* Table */}
                <div className="w-full overflow-x-auto pt-checklist-table">
                <table className="w-full text-left border-collapse">
                    <thead>
                    <tr className="text-[#19335C] text-sm font-semibold border-b border-[#eeeeee]">
                        <th className="py-4 px-[7px] md:w-[60%] w-[40%]">&nbsp;</th>
                        <th className="py-4 px-[7px] text-center md:w-[26%] w-[30%] relative">
                            <div className="image-div">
                            {yesHearingImage ? (
                                <img src={yesHearingImage.localFile.publicURL} alt={yesHearingImage.altText} className="yesHearingLogoImage mx-auto"/>
                            ):(
                                <span className="yesHearingLogoText">YesHearing</span>
                            )}
                            </div>
                        </th>
                        <th className="py-4  text-center w-[30%] md:w-[14%] leading-[15px]">OTC and Telehealth Hearing Aids</th>
                    </tr>
                    </thead>
                    <tbody className="text-[#3D4F68] text-sm">
                    {features && features.length > 0 ? features.map((item, i) => (
                        <tr key={i} className="border-b border-[#eeeeee] hover:bg-gray-50 transition leading-[26px]">
                        <td className="py-4 px-[7px]">{item.featureTitle}</td>
                        <td className="py-4 px-[7px] text-center">
                            {item.featureType === 'yeshearing' ? (
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#4CAF50", // Green background
                                    color: "white",            // White tick
                                    borderRadius: "50px",       // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px"
                                }}>
                                    <Tick />
                                </span>
                            ) : item.featureType === 'both' ? (
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#4CAF50", // Green background
                                    color: "white",            // White tick
                                    borderRadius: "50px",       // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px"
                                }}>
                                    <Tick />
                                </span>
                            ) : (
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#e0e0e0", // Light grey background
                                    color: "#616161",           // Dark grey cross
                                    borderRadius: "50px",        // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px"
                                }}>
                                    <ThinCross />
                                </span>
                            )}
                        </td>
                        <td className="py-4 px-[7px] text-center">
                        {item.featureType === 'both' ? (
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#4CAF50", // Green background
                                    color: "white",            // White tick
                                    borderRadius: "50px",       // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px"
                                }}>
                                    <Tick />
                                </span>
                            ) : (
                                <span style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#e0e0e0", // Light grey background
                                    color: "#616161",           // Dark grey cross
                                    borderRadius: "50px",        // Slightly rounded corners
                                    margin: "0 2px",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px"
                                }}>
                                    <ThinCross />
                                </span>
                            )}
                        </td>
                        </tr>
                    )) : null}
                    </tbody>
                </table>
                </div>
            </div>
        </section>
      );
      
 };